import classNames from 'classnames';
import Link from 'next/link';

interface CategoryProps {
  category: string;
  section: string;
  decodedPathname: string;
  link: string;
}

const handleClick = () => {
  // console.log('click');
};
export default function CategoryLink({
  category,
  section,
  decodedPathname,
  link,
}: CategoryProps) {
  const isActive = decodedPathname === link;
  // console.log('isActive', isActive);
  const isSpecialSection =
    section === 'man' || section === 'home' || section === 'children';
  const isWhiteText =
    isActive && (section === 'home' || section === 'children');

  const classes = classNames('rounded-xl px-3 py-1', {
    [`bg-${section}-active`]: isActive,
    'text-black': isActive && !isWhiteText,
    'text-white': isWhiteText,
    'bg-transparent': !isActive && isSpecialSection,
    'bg-red-light': !isActive && !isSpecialSection,
  });

  return (
    <Link href={link} onClick={handleClick} prefetch={true} passHref>
      <li className={classes}>{category}</li>
    </Link>
  );
}
